import script from "./AboutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutModal.vue?vue&type=script&setup=true&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=85fdbe44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85fdbe44"]])

export default __exports__